import React from 'react';
import { useHistory } from 'react-router-dom';
import { Portlet } from '../../../../_metronic/partials/content/Portlet';
import { CustomButton, Typography } from '../../components';

const SchedulesAnnounce = () => {
  const history = useHistory();
  return (
    <Portlet className='p-4'>
      <Typography className='mb-4' variant='h1'>
        VERIFY YOUR 2024 PICK-UP AND/OR EVENT SCHEDULES
      </Typography>
      <Typography className='mb-4' variant='h2Medium' style={{ fontSize: 14 }}>
        Make the transition into the new year as seamless as possible for your
        residents! If you haven’t already, please fill out the form below to
        submit your 2024 calendar information. And don't forget to hit the
        Schedules tab to ensure your holiday collection is captured correctly.{' '}
      </Typography>
      <div className='d-flex justify-flex-end'>
        <a
          href='https://share.hsforms.com/1ByQkxTAqTdCEvBf929ppFAe4tiu'
          target='_blank'
        >
          <CustomButton
            size='large'
            variant='contained'
            fontSize={14}
            style={{ width: 'max-content' }}
            paddingVertical={2}
            label={'SUBMIT NOW'}
          />
        </a>
      </div>

      {/* <button
        type='button'
        onClick={() => history.push('/schedules')}
        style={{
          color: '#404040',
          textDecoration: 'underline',
          border: 'none',
          width: 'max-content',
          background: 'transparent',
          fontSize: '14px',
          marginLeft: '-5px',
        }}
      >
        Take me there
      </button> */}
    </Portlet>
  );
};

export default SchedulesAnnounce;
